import NavBar from './NavBar.vue';

// @ts-ignore
NavBar.install = (Vue) => {
  Vue.component((NavBar as any).options.name, NavBar);
};

export default NavBar;
